<template>
    <div>
        <firm-dashboard :user-details="userDetails" />
        <div class="CustomerCard">
            <div>
                <div class="h4">
                    Your clients
                    <el-button v-if="!isViewingAsOther" class="btnNext" ref="Customers" @click="AddCustomer">Create new client </el-button>
                </div>
                <div>
                    <el-button class="Credits">Search for a client, Edit their report or Create a new quote for a customer.</el-button>
                </div>
                <div>
                    <el-input v-model="FilterCustomer" v-on:change="FilterCustomerChange" placeholder="Search by customer name" class="SearchCustomers" prefix-icon="Search"> </el-input>
                </div>
                <div class="retention-notice" role="note">
                    <span class="retention-notice__icon" aria-hidden="true">i</span>
                    <span class="retention-notice__text">Remember we only store quotes for 30 days, so please save them locally if you need access to them for longer.</span>
                </div>
                <div v-if="UserCustomers !== null && UserCustomersAnalysis !== null">
                    <div v-for="customer in UserCustomers" :key="customer.customerReference" class="customer-block">
                        <div class="customer-header" :class="{ 'customer-header--collapsed': isCustomerCollapsed(customer.customerReference) }" @click="toggleCustomerCollapsed(customer.customerReference)">
                            <div class="customer-identity">
                                <span class="customer-chevron" :class="{ 'customer-chevron--collapsed': isCustomerCollapsed(customer.customerReference) }">▾</span>
                                <div class="customer-avatar">{{ customer.customerName.charAt(0) + customer.customerName.split(' ')[1].charAt(0) }}</div>
                                <div class="customer-name-block">
                                    <div class="customer-name">{{ customer.customerName }}</div>
                                    <div class="customer-count" :class="{ 'customer-count--loading': !analysesLoadedFor[customer.customerReference] }">
                                        <template v-if="analysesLoadedFor[customer.customerReference]">{{ analysisCountFor(customer.customerReference) }} {{ analysisCountFor(customer.customerReference) === 1 ? 'analysis' : 'analyses' }}</template>
                                        <template v-else>Loading analyses…</template>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isViewingAsOther" class="customer-actions">
                                <button class="customer-btn customer-btn--secondary" @click.stop="EditCustomer(customer.customerReference)">Edit client details</button>
                                <button class="customer-btn customer-btn--primary" @click.stop="RunAnalysis(customer.customerReference)">Run new analysis</button>
                            </div>
                        </div>
                        <div v-show="!isCustomerCollapsed(customer.customerReference)" class="customer-analyses">
                            <analysis-card
                                v-for="analysis in UserCustomersAnalysis.filter(function(a){ return a.customerReference === customer.customerReference; })"
                                :key="analysis.analysisReference"
                                :analysis="analysis"
                                :reports-count="(CustomerReports || []).filter(function(r){ return r.analysisReference === analysis.analysisReference; }).length"
                                @view-results="onViewResults"
                                @complete-underwriting="OpenIntegratorSite"
                            >
                                <template #reports-action="{ reportsCount }">
                                    <el-popover
                                        v-if="reportsCount > 0"
                                        placement="left"
                                        trigger="click"
                                    >
                                        <template #default>
                                            <el-table
                                                :data="CustomerReports.filter(function(report){ return report.analysisReference === analysis.analysisReference; }).map(function(f) { return { func: function() { DownloadAnalysisReport(analysis.customerReference, analysis.analysisReference, f.reportReference); }, reportReference: f.reportReference, expires: displayDate(f.expires), title: f.title }; })"
                                                style="width: 100% !important"
                                            >
                                                <el-table-column prop="title" label="Title" width="180"></el-table-column>
                                                <el-table-column width="120" label="Expires">
                                                    <template #default="scope">
                                                        <label>{{ scope.row.expires }}</label>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column fixed="right" label="Action" width="120">
                                                    <template #default="scope">
                                                        <el-button v-if="scope.row.reportReference !== ''" @click="scope.row.func()">Download</el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </template>
                                        <template #reference>
                                            <button class="card-reports-btn">Reports ({{ reportsCount }})</button>
                                        </template>
                                    </el-popover>
                                    <button v-else class="card-reports-btn card-reports-btn--disabled" disabled>Reports (0)</button>
                                </template>
                            </analysis-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="UserCustomers === null || UserCustomersAnalysis === null">
            <loading-control :loading-message="'Loading customers…'" />
        </div>
    </div>
</template>
<style>
    .el-popper .is-light .el-popover {
        z-index: 2353 !important;
        position: absolute !important;
        inset: 0px 0px auto auto !important;
        margin: 0px !important;
        transform: translate(-585px, 223px) !important;
        width: 450px !important;
    }
</style>
<style>
    /*.el-popper.is-light {*/
    /*width: 430px !important;*/
    /*}*/

    .el-popover.el-popper {
        width: 430px !important;
    }
</style>
<style type="text/css" scoped>
    .el-popper.is-light {
        width: 430px !important;
    }

    .el-button + .el-button {
        margin-left: 0px !important;
        padding: 0px !important;
    }

    .el-button {
        padding: 8px !important;
    }

    .el-button--text:focus, .el-button--text:hover {
        color: black;
    }

    .el-button:hover {
        background: none !important
    }

    .customerDetail {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px;
        position: static;
        width: 1012px;
        background: #F3F2EF !important;
        border-radius: 8px;
        margin: 16px 0px;
        margin-left: auto;
        margin-right: auto;
    }

    .btnText {
        color: black;
    }

        .btnText:hover {
            color: black;
            background: none !important;
        }

    .TermAnalysisData {
        justify-content: space-between;
        color: #252525;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
        position: static;
        width: 1086px;
        height: 45px;
        background-color: #FFFFFF;
        order: 1;
        flex-grow: 0;
        margin-top: 5px;
    }

    .Analysis {
        width: 350px;
        height: 25px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        padding-left: 5px;
    }

    .analysisDate {
        width: 170px;
        height: 25px;
        top: 0px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
    }

    .el-button {
        font-weight: 600 !important;
        border: none !important
    }

    .ResultsAndReports {
        font-family: 'Inter' !important;
        font-style: normal !important;
        font-size: 16px !important;
        display: flex !important;
        display: flex !important;
        align-items: flex-end !important;
        text-align: right !important;
        padding-right: 5px !important;
        width: 200px;
    }

    .el-icon-arrow-down {
        font-weight: bolder;
        color: black;
        margin-left: 5px;
    }

    .AnalysisData {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px;
        position: static;
        background: #FFFFFF;
    }

    .NamedTag {
        font-family: 'Lato';
        font-style: normal;
        font-weight: 700;
        padding: 4px;
        font-size: 21px;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        color: #FFFFFF;
        background: #245A6E;
        border-radius: 4px;
        width: 44px;
        height: 44px;
    }

    .CustomerNames {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        align-items: center;
        color: #333333;
        margin-left: 15px;
    }

    .tableData {
        position: initial !important;
        width: 1010px !important;
        height: auto !important;
        left: 16px !important;
        top: 16px !important;
        color: #252525 !important;
        order: 0 !important;
        flex-grow: 0 !important;
        margin: 0px 0px !important;
    }

    .btnRunAnalysis, .btnRunAnalysis:hover {
        float: right;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        width: 153px;
        height: 44px;
        border: 1px solid black !important;
        box-sizing: border-box !important;
        border-radius: 8px !important;
        color: black !important;
        background: rgb(243, 242, 239) !important;
        margin-left: 10px;
    }

    .SearchCustomers {
        width: 100% !important;
        box-sizing: border-box !important;
        border-radius: 8px !important;
        border-color: #333333 !important;
    }

    .retention-notice {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #F4F6FB;
        border: 1px solid #DDE2F0;
        border-radius: 10px;
        padding: 10px 14px;
        margin: 14px 0 4px;
        font-family: 'Inter', sans-serif;
        font-size: 12.5px;
        line-height: 1.45;
        color: #4a4f63;
    }
    .retention-notice__icon {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #353C8E;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-family: 'Georgia', serif;
        font-style: italic;
        font-weight: 700;
        font-size: 13px;
        line-height: 1;
    }
    .retention-notice__text {
        min-width: 0;
    }

    .CustomerCard {
        /*display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;*/
        /*box-sizing: border-box;*/
        max-width: 1240px !important;
        min-width: 1044px !important;
        width: 100% !important;
        margin-left: auto !important;
        margin-right: auto !important;
        top: 24px !important;
        border-radius: 8px !important;
        margin-top: 50px !important;
        padding: 24px 24px 8px !important;
        background-color: #FFFFFF !important;
        /*overflow-y: scroll;*/
        margin-top: 24px !important;
    }

    .MoreCredits {
        color: #46A3F8;
    }

    .btnNext {
        border-radius: 8px;
        float: right;
        background-color: #49A267 !important;
        position: static;
        width: 161px;
        height: 44px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        display: flex;
        align-items: center;
        color: #FFFFFF !important;
        text-align: center;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
        transition: background-color 0.15s, box-shadow 0.15s;
    }

        .btnNext:hover {
            border-radius: 8px;
            float: right;
            background-color: #3F8E59 !important;
            position: static;
            width: 161px;
            height: 44px;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 700;
            display: flex;
            align-items: center;
            color: #FFFFFF !important;
            text-align: center;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
        }

    .Credits {
        font-family: 'Inter' !important;
        font-style: normal !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 41px;
        display: contents;
        align-items: center;
        letter-spacing: -0.04em;
        color: #0F172A !important;
    }

    .analysisStyles button {
        max-width: 80px;
        display: inline-block;
        margin-right: 10px;
    }

        .analysisStyles button:last-child {
            margin-right: 0px;
        }

    .analysisStyles th:last-child, .analysisStyles td:last-child {
        width: 200px;
    }
    .logo {
        flex: 1;
        display: flex;
        justify-content: center;
    }

     .logo img {
        width: 130px;
    }
    .logo p {
        font-weight: bold;
    }

    .card-reports-btn {
        background: transparent;
        color: #353C8E;
        border: 0;
        padding: 6px 2px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        transition: color 0.15s;
    }
    .card-reports-btn::after {
        content: '→';
        display: inline-block;
        transition: transform 0.15s;
    }
    .card-reports-btn:hover {
        color: #1f266e;
    }
    .card-reports-btn:hover::after {
        transform: translateX(2px);
    }
    .card-reports-btn--disabled,
    .card-reports-btn--disabled:hover {
        color: #c1c4d4;
        cursor: not-allowed;
    }
    .card-reports-btn--disabled:hover::after {
        transform: none;
    }

    /* Customer wrapper — visually groups header + its analyses together */
    .customer-block {
        background: #F4F5FA;
        border: 1px solid #e3e5ee;
        border-radius: 18px;
        padding: 12px 12px 4px;
        margin: 20px auto;
        max-width: 1200px;
        width: 100%;
    }
    /* The cards inside live on top of the soft wrapper bg, no extra outer margin needed. */
    .customer-analyses {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .customer-block :deep(.pgp-card) {
        margin-bottom: 10px;
        width: 98%;
        box-sizing: border-box;
    }
    .customer-block :deep(.pgp-card:last-child) {
        margin-bottom: 8px;
    }

    .customer-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
        padding: 14px 18px;
        background: #fff;
        border: 1px solid #e9eaf0;
        border-radius: 12px;
        margin-bottom: 10px;
        box-shadow: 0 1px 2px rgba(20, 20, 40, 0.04);
        font-family: 'Inter', sans-serif;
        cursor: pointer;
        user-select: none;
        transition: background 0.15s, box-shadow 0.15s;
    }
    .customer-header:hover {
        background: #FAFAFC;
        box-shadow: 0 2px 6px rgba(20, 20, 40, 0.06);
    }
    .customer-header--collapsed {
        margin-bottom: 0;
    }

    .customer-chevron {
        font-size: 16px;
        color: #8b90a3;
        transition: transform 0.18s ease;
        display: inline-block;
        line-height: 1;
        margin-right: 2px;
    }
    .customer-chevron--collapsed {
        transform: rotate(-90deg);
    }

    .customer-identity {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
    }
    .customer-name-block {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
    }
    .customer-count {
        font-size: 11px;
        color: #8b90a3;
        font-weight: 500;
    }
    .customer-count--loading {
        font-style: italic;
        opacity: 0.75;
    }

    .customer-avatar {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: #353C8E;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 15px;
        letter-spacing: 0.4px;
        flex-shrink: 0;
    }

    .customer-name {
        font-size: 17px;
        font-weight: 600;
        color: #1a1d2b;
        letter-spacing: -0.2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .customer-actions {
        display: flex;
        gap: 8px;
        flex-shrink: 0;
    }

    .customer-btn {
        padding: 7px 22px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        font-family: 'Inter', sans-serif;
        cursor: pointer;
        transition: background 0.15s, box-shadow 0.15s;
        white-space: nowrap;
        line-height: 1.4;
    }

    .customer-btn--primary {
        background: #49A267;
        color: #fff;
        border: 1.5px solid #49A267;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.10);
    }
    .customer-btn--primary:hover {
        background: #3F8E59;
        border-color: #3F8E59;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
    }

    .customer-btn--secondary {
        background: transparent;
        color: #353C8E;
        border: 1.5px solid #c9ccdb;
    }
    .customer-btn--secondary:hover {
        background: rgba(53, 60, 142, 0.06);
        border-color: #353C8E;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    }
</style>

<script>
    import $ from 'jquery';
    import LoadingControl from './LoadingControl.vue';
    import FirmDashboard from './FirmDashboard.vue';
    import AnalysisCard from './AnalysisCard.vue';
    import helper from './HelperMethods.vue';
    import { useViewAs } from '../composables/useViewAs';

    export default {
        name: 'CustomerControl',
        props: ["userSelection", "userDetails"],
        components: {
            LoadingControl,
            FirmDashboard,
            AnalysisCard,
        },
        setup() {
            const { getViewAsParam, isViewingAsOther } = useViewAs()
            return { getViewAsParam, isViewingAsOther }
        },
        computed: {
            UserSelection: function () { return this.userSelection; },
            UserDetails: function () { return this.userDetails; }
        },
        data: function () {
            return {
                mainUserCustomer: [],
                SelectedCustomer: null,
                UserCustomers: [],
                UserCustomersAnalysis: [],
                FilterCustomer: '',
                CustomerReports: [],
                // Tracks which customer rows are collapsed. Default state is expanded —
                // a customer is collapsed only when its reference is in this map.
                collapsedCustomers: {},
                // Tracks which customers have completed their analyses fetch. Used to
                // suppress the "0 analyses" flash on initial load and after refresh.
                analysesLoadedFor: {},
            }
        },

        //beforeMount: async function () {
        //    // Added mounted for Create New Client Button but it bypass the screen and showing client details screen.
        //    await this.AddCustomer();
        //},

        //mounted: async function () {
        //    // Added mounted for Create New Client Button but it bypass the screen and showing client details screen.
        //    //await this.AddCustomer();
        //    await this.insertBefore(this.AddCustomer());
        //},
        //insertBefore: async function () {
        //    await this.insertBefore(this.AddCustomer());
        //    //await this.AddCustomer();
        //},
        /*updated: async function () {
            //await this.insertBefore(this.AddCustomer());
            await !this.AddCustomer();
        }, */
        methods: {
            // Appends viewAs query param to a URL if viewing as another user
            appendViewAs: function (url) {
                var viewAs = this.getViewAsParam()
                if (!viewAs) return url
                var separator = url.includes('?') ? '&' : '?'
                return url + separator + 'viewAs=' + encodeURIComponent(viewAs)
            },
            displayDate: function (d) {
                if (d === null)
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            RefreshCustomers: function () {
                this.UserCustomersAnalysis = [];
                this.CustomerReports = [];
                this.analysesLoadedFor = {};
                this.DownloadCustomers(function () { });
                this.DownloadReports(function () { });
            },
            DownloadCustomers: function (actionIfEmpty) {
                var thisControl = this;

                thisControl.UserCustomers = [];
                thisControl.UserCustomersAnalysis = [];
                thisControl.analysesLoadedFor = {};

                $.ajax({
                    type: 'GET',
                    url: thisControl.appendViewAs('/Customer/'),
                    contentType: 'application/json',
                    success: function (customers) {

                        customers.sort((a, b) =>
                            a.customerName.split('&')[0].trim().split(' ').slice(-1)[0].toLowerCase()
                                .localeCompare(
                                    b.customerName.split('&')[0].trim().split(' ').slice(-1)[0].toLowerCase()
                                )
                        );

                        thisControl.UserCustomers = customers;
                        thisControl.mainUserCustomer = customers;

                        if (thisControl.UserCustomers.length === 0) {
                            actionIfEmpty();
                        }

                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        actionIfEmpty();
                    }
                });



            },
            DownloadCustomerAnalysis: function (customerReferece) {
                var thisControl = this;

                $.ajax({
                    type: 'GET',
                    url: thisControl.appendViewAs('/CustomerAnalysis/' + customerReferece),
                    contentType: 'application/json',
                    success: function (analysis) {
                        if (analysis.length > 0 && analysis !== null)
                            thisControl.UserCustomersAnalysis = helper.mergeArrays([thisControl.UserCustomersAnalysis, analysis.sort(function (a, b) { return a.expires < b.expires ? 1 : -1; })]);
                        thisControl.analysesLoadedFor = Object.assign({}, thisControl.analysesLoadedFor, { [customerReferece]: true });
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                        thisControl.analysesLoadedFor = Object.assign({}, thisControl.analysesLoadedFor, { [customerReferece]: true });
                    }
                });
            },
            LoadTool: function (customerReference) {
                var us = this.UserSelection;
                us.selectedCustomerType = null;
                us.customerReference = customerReference;
                this.$emit('customer-selected');
            },
            onViewResults: function ({ customerReference, analysisReference }) {
                this.LoadAnalysis(customerReference, analysisReference);
            },
            isCustomerCollapsed: function (customerReference) {
                return !!this.collapsedCustomers[customerReference];
            },
            toggleCustomerCollapsed: function (customerReference) {
                if (this.collapsedCustomers[customerReference]) {
                    delete this.collapsedCustomers[customerReference];
                } else {
                    this.collapsedCustomers[customerReference] = true;
                }
                // Force reactivity for the v-show binding (Vue 3 Proxy handles delete,
                // but we re-assign defensively for the @vue/compat layer in this repo).
                this.collapsedCustomers = { ...this.collapsedCustomers };
            },
            analysisCountFor: function (customerReference) {
                if (!this.UserCustomersAnalysis) return 0;
                return this.UserCustomersAnalysis.filter(function (a) {
                    return a.customerReference === customerReference;
                }).length;
            },
            LoadAnalysis: function (customerReference, analysisReference) {

                var thisControl = this;
                thisControl.UserSelection.customerReference = customerReference;

                $.ajax({
                    type: 'GET',
                    url: thisControl.appendViewAs('/CustomerAnalysis/' + thisControl.UserSelection.customerReference + '/' + analysisReference),
                    contentType: 'application/json',
                    success: function (data) {
                        if (data.userSelection !== null) {
                            if (data.analysis.analysisReferecnce === undefined) {
                                data.analysis.analysisReferecnce = analysisReference;
                            }
                            thisControl.SetUserSelection(data.userSelection, data.analysis);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                    }
                });
            },
            SetUserSelection: function (StoredUserSelection, analysis) {
                this.$emit('analysis-selected', StoredUserSelection, analysis);
            },
            RunAnalysis: function (customerReference) {
                this.UserSelection.selectedCustomerType = null;
                this.UserSelection.customerReference = customerReference;
                
                this.$emit("load-tool-selection");
            },
            FilterCustomerChange: function (evt) {
                this.UserCustomers = this.mainUserCustomer.filter(function (uCustomer) {
                    return uCustomer.customerName.toLowerCase().includes(evt.toLowerCase(), 0);
                });
            },
            AddCustomer: function () {
                this.UserSelection.customerReference = null;
                this.$emit('add-customer');
                this.$router.push({ name: "Customers"});
            },
            EditCustomer: function (customerReference) {
                this.UserSelection.customerReference = customerReference;
                this.$emit('edit-customer')
            },
            DownloadReports: function () {
                var thisControl = this;

                $.ajax({
                    type: 'GET',
                    url: thisControl.appendViewAs('/CustomerReport/'),
                    contentType: 'application/json',
                    success: function (reports) {
                        thisControl.CustomerReports = reports;
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location = "./Api/signin";
                            return;
                        }
                    }
                });
            },
            DownloadAnalysisReport: function (customerReference, analysisReference, reportReference) {
                this.visible = false;

                window.open(this.appendViewAs('/CustomerReport/' + customerReference + "/" + analysisReference + "/" + reportReference), '_self');
            },
            OpenIntegratorSite: function(externalApplicationId)
            {
                window.open(externalApplicationId, '_blank').focus();
            }
        },
        mounted: function () {
            this.RefreshCustomers();
            this.UserSelection.selectedCustomerType = 0;
        },
        watch:
        {
            "mainUserCustomer": function () {
                var thisContorl = this;

                this.mainUserCustomer.forEach(function (cus) {
                    thisContorl.DownloadCustomerAnalysis(cus.customerReference);

                });
            },
            "FilterCustomerData": function (evt) {
                this.UserCustomersAnalysis = [];
                this.UserCustomers = [];

                this.UserCustomers = this.mainUserCustomer.filter(function (uCustomer) {
                    return uCustomer.customerName.toLowerCase().includes(evt.toLowerCase(), 0);
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
